import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { initPerformanceOptimizations } from "./utils/webVitals";

// Initialize performance optimizations early
initPerformanceOptimizations();

// Create a root container
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

// Render your app with React 18 syntax
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// PWA install prompt disabled: unregister any previously installed service worker
// so existing visitors stop seeing the browser "Install app" prompt.
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
